import React from 'react';

import './LandingPageMoreTransactions.scss';

import {
  getMoreTransactions529,
  moreTransactions,
  qcdLanding,
} from '../../../containers/TransactionLandingPage/TransactionLandingPageContent';
import { ProductTypes } from '../../../settings/settings';
import { toLowerKebabCase } from '../../../utils/utils';
const LandingPageMoreTransactions = ({
  age = 0,
  collegeTypes,
  hasCollegeOnly,
  hasMixedCollegeTypes,
  isRolloverOrTraditionalIRAFund,
}) => {
  const { hasMD529, hasNAT529 } = collegeTypes;
  const collegeType = hasNAT529
    ? ProductTypes.NATIONAL529
    : hasMD529
    ? ProductTypes.MARYLAND529
    : ProductTypes.ALASKA529;
  let content;
  if (hasCollegeOnly && hasMixedCollegeTypes) {
    content = getMoreTransactions529();
  } else if (hasCollegeOnly && !hasMixedCollegeTypes) {
    content = getMoreTransactions529(collegeType);
  } else {
    content = isRolloverOrTraditionalIRAFund
      ? moreTransactions
      : moreTransactions.filter(
          (transaction) => transaction.title !== 'Roth Conversion'
        );
    if (age >= 70.5) {
      content = [...content, qcdLanding];
    }
  }
  return (
    <div className="landing-page-more-transactions-container">
      <div className="container">
        <h4 className="landing-page-more-transactions-title">
          More Transactions
        </h4>
        <div className="e2e-transaction-list landing-page-more-transactions-transaction-list">
          {content.map(({ description, link, title }) => (
            <div
              key={title}
              className="landing-page-more-transactions-transaction"
            >
              <a
                alt={`${title}-link`}
                className="college-branded-link landing-page-more-transactions-action"
                href={link}
                id={`landing-page-more-${toLowerKebabCase(title)}-link`}
              >
                {title}
              </a>
              <p className="landing-page-more-transactions-description">
                {description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LandingPageMoreTransactions;
